import {
  Add,
  ArrowBack,
  ArrowDropDown,
  ArrowDropUp,
  AddPhotoAlternateOutlined,
  ArrowRight,
  Block,
  CallOutlined,
  CheckBox,
  CheckBoxOutlineBlank,
  CheckCircleOutline,
  Close,
  DateRangeOutlined,
  DeleteOutlined,
  Done,
  EditOutlined,
  ExpandLess,
  ExpandMore,
  FirstPage,
  FormatBold,
  FormatItalic,
  FormatListBulleted,
  FormatListNumbered,
  FormatUnderlined,
  GetApp,
  KeyboardArrowLeft,
  KeyboardArrowRight,
  LastPage,
  MailOutlined,
  MoreHoriz,
  PhoneForwardedOutlined,
  PrintOutlined,
  RadioButtonChecked,
  RadioButtonUnchecked,
  Redo,
  Refresh,
  RemoveCircleOutlined,
  Restore,
  Search,
  SpeakerNotesOutlined,
  Star,
  StarBorder,
  TextFormat,
  Timeline,
  Timer,
  UnarchiveOutlined,
  Undo,
  Visibility,
  VisibilityOff,
  Attachment,
  LocalPhoneOutlined,
  Public,
  LibraryBooks,
  InfoOutlined,
  RecordVoiceOverOutlined,
  PhoneInTalkOutlined,
  SettingsOutlined,
  ScheduleOutlined,
  ManageAccountsOutlined,
  AccountBoxOutlined,
  ContactPhoneOutlined,
} from '@mui/icons-material';

const Icons = {
  addPhoto: <AddPhotoAlternateOutlined />,
  attachment: <Attachment />,
  arrowDropDown: <ArrowDropDown />,
  arrowRight: <ArrowRight />,
  firstPage: <FirstPage />,
  lastPage: <LastPage />,
  keyboardArrowLeft: <KeyboardArrowLeft />,
  keyboardArrowRight: <KeyboardArrowRight />,
  arrowDropUp: <ArrowDropUp />,
  checkCircle: <CheckCircleOutline />,
  arrowBack: <ArrowBack />,
  expandLess: <ExpandLess />,
  expandMore: <ExpandMore />,
  speakerNotes: <SpeakerNotesOutlined />,
  block: <Block />,
  add: <Add />,
  search: <Search />,
  dateRange: <DateRangeOutlined />,
  moreHoriz: <MoreHoriz />,
  print: <PrintOutlined />,
  delete: <DeleteOutlined />,
  close: <Close />,
  edit: <EditOutlined />,
  done: <Done />,
  call: <CallOutlined />,
  refresh: <Refresh />,
  checkboxFilled: <CheckBox />,
  checkBoxBlank: <CheckBoxOutlineBlank />,
  unarchive: <UnarchiveOutlined />,
  fileDownload: <GetApp />,
  restore: <Restore />,
  undo: <Undo />,
  redo: <Redo />,
  formatBold: <FormatBold />,
  formatItalic: <FormatItalic />,
  formatUnderlined: <FormatUnderlined />,
  formatListBulleted: <FormatListBulleted />,
  formatListNumbered: <FormatListNumbered />,
  textFormat: <TextFormat />,
  visibilityOff: <VisibilityOff />,
  visibility: <Visibility />,
  starBorder: <StarBorder />,
  star: <Star />,
  radioButtonUnchecked: <RadioButtonUnchecked />,
  radioButtonChecked: <RadioButtonChecked />,
  mail: <MailOutlined />,
  removeCircleOutlined: <RemoveCircleOutlined />,
  timeline: <Timeline />,
  phoneForwarded: <PhoneForwardedOutlined />,
  timer: <Timer />,
  phone: <LocalPhoneOutlined />,
  public: <Public />,
  libraryBooks: <LibraryBooks />,
  infoOutlined: <InfoOutlined />,
  callRecording: <RecordVoiceOverOutlined />,
  voiceProvider: <PhoneInTalkOutlined />,
  settings: <SettingsOutlined />,
  timePicker: <ScheduleOutlined />,
  dialerSubAccount: <ManageAccountsOutlined />,
  accountSettings: <AccountBoxOutlined />,
  lookup: <ContactPhoneOutlined />,
  logout: (
    <>
      <g>
        <path d="M0,0h24v24H0V0z" fill="none" />
      </g>
      <g>
        <path d="M17,8l-1.41,1.41L17.17,11H9v2h8.17l-1.58,1.58L17,16l4-4L17,8z M5,5h7V3H5C3.9,3,3,3.9,3,5v14c0,1.1,0.9,2,2,2h7v-2H5V5z" />
      </g>
    </>
  ),
  sorting: (
    <g>
      <path d="M7 13L12 18L17 13H7Z" />
      <path d="M7 11L12 6L17 11H7Z" />
    </g>
  ),
  summarize: (
    <>
      <g>
        <path d="M0,0h24v24H0V0z" fill="none" />
      </g>
      <g>
        <g>
          <path d="M15,3H5C3.9,3,3.01,3.9,3.01,5L3,19c0,1.1,0.89,2,1.99,2H19c1.1,0,2-0.9,2-2V9L15,3z M5,19V5h9v5h5v9H5z M9,8 c0,0.55-0.45,1-1,1S7,8.55,7,8s0.45-1,1-1S9,7.45,9,8z M9,12c0,0.55-0.45,1-1,1s-1-0.45-1-1s0.45-1,1-1S9,11.45,9,12z M9,16 c0,0.55-0.45,1-1,1s-1-0.45-1-1s0.45-1,1-1S9,15.45,9,16z" />
        </g>
      </g>
    </>
  ),
  filterAltOutlined: (
    <g>
      <path d="M0,0h24 M24,24H0" fill="none" />
      <path d="M7,6h10l-5.01,6.3L7,6z M4.25,5.61C6.27,8.2,10,13,10,13v6c0,0.55,0.45,1,1,1h2c0.55,0,1-0.45,1-1v-6 c0,0,3.72-4.8,5.74-7.39C20.25,4.95,19.78,4,18.95,4H5.04C4.21,4,3.74,4.95,4.25,5.61z" />
      <path d="M0,0h24v24H0V0z" fill="none" />
    </g>
  ),
  filterAlt: (
    <g>
      <path d="M0,0h24 M24,24H0" fill="none" />
      <path d="M4.25,5.61C6.27,8.2,10,13,10,13v6c0,0.55,0.45,1,1,1h2c0.55,0,1-0.45,1-1v-6c0,0,3.72-4.8,5.74-7.39 C20.25,4.95,19.78,4,18.95,4H5.04C4.21,4,3.74,4.95,4.25,5.61z" />
      <path d="M0,0h24v24H0V0z" fill="none" />
    </g>
  ),
  fileUpload: (
    <>
      <g>
        <rect fill="none" height="24" width="24" />
      </g>
      <g>
        <path d="M18,15v3H6v-3H4v3c0,1.1,0.9,2,2,2h12c1.1,0,2-0.9,2-2v-3H18z M7,9l1.41,1.41L11,7.83V16h2V7.83l2.59,2.58L17,9l-5-5L7,9z" />
      </g>
    </>
  ),
  groups: (
    <>
      <rect fill="none" height="24" width="24" />
      <g>
        <path d="M4,13c1.1,0,2-0.9,2-2c0-1.1-0.9-2-2-2s-2,0.9-2,2C2,12.1,2.9,13,4,13z M5.13,14.1C4.76,14.04,4.39,14,4,14 c-0.99,0-1.93,0.21-2.78,0.58C0.48,14.9,0,15.62,0,16.43V18l4.5,0v-1.61C4.5,15.56,4.73,14.78,5.13,14.1z M20,13c1.1,0,2-0.9,2-2 c0-1.1-0.9-2-2-2s-2,0.9-2,2C18,12.1,18.9,13,20,13z M24,16.43c0-0.81-0.48-1.53-1.22-1.85C21.93,14.21,20.99,14,20,14 c-0.39,0-0.76,0.04-1.13,0.1c0.4,0.68,0.63,1.46,0.63,2.29V18l4.5,0V16.43z M16.24,13.65c-1.17-0.52-2.61-0.9-4.24-0.9 c-1.63,0-3.07,0.39-4.24,0.9C6.68,14.13,6,15.21,6,16.39V18h12v-1.61C18,15.21,17.32,14.13,16.24,13.65z M8.07,16 c0.09-0.23,0.13-0.39,0.91-0.69c0.97-0.38,1.99-0.56,3.02-0.56s2.05,0.18,3.02,0.56c0.77,0.3,0.81,0.46,0.91,0.69H8.07z M12,8 c0.55,0,1,0.45,1,1s-0.45,1-1,1s-1-0.45-1-1S11.45,8,12,8 M12,6c-1.66,0-3,1.34-3,3c0,1.66,1.34,3,3,3s3-1.34,3-3 C15,7.34,13.66,6,12,6L12,6z" />
      </g>
    </>
  ),
  contentCut: (
    <g>
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M9.64 7.64c.23-.5.36-1.05.36-1.64 0-2.21-1.79-4-4-4S2 3.79 2 6s1.79 4 4 4c.59 0 1.14-.13 1.64-.36L10 12l-2.36 2.36C7.14 14.13 6.59 14 6 14c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4c0-.59-.13-1.14-.36-1.64L12 14l7 7h3v-1L9.64 7.64zM6 8c-1.1 0-2-.89-2-2s.9-2 2-2 2 .89 2 2-.9 2-2 2zm0 12c-1.1 0-2-.89-2-2s.9-2 2-2 2 .89 2 2-.9 2-2 2zm6-7.5c-.28 0-.5-.22-.5-.5s.22-.5.5-.5.5.22.5.5-.22.5-.5.5zM19 3l-6 6 2 2 7-7V3h-3z" />
    </g>
  ),
  contentCopy: (
    <g>
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z" />
    </g>
  ),
  sendAndArchive: (
    <>
      <g>
        <rect fill="none" height="24" width="24" />
      </g>
      <g>
        <g>
          <g>
            <path d="M11,12l-6-1.5V7.01l8.87,3.73c0.94-0.47,2-0.75,3.13-0.75c0.1,0,0.19,0.01,0.28,0.01L3,4v16l7-2.95c0-0.02,0-0.03,0-0.05 c0-0.8,0.14-1.56,0.39-2.28L5,16.99V13.5L11,12z" />
          </g>
          <g>
            <path d="M17,12c-2.76,0-5,2.24-5,5s2.24,5,5,5s5-2.24,5-5S19.76,12,17,12z M17,20l-3-3l0.71-0.71l1.79,1.79V14h1v4.09l1.79-1.79 L20,17L17,20z" />
          </g>
        </g>
      </g>
    </>
  ),
  dangerous: (
    <>
      <g>
        <path d="M0,0h24v24H0V0z" fill="none" />
      </g>
      <g>
        <path d="M15.73,3H8.27L3,8.27v7.46L8.27,21h7.46L21,15.73V8.27L15.73,3z M19,14.9L14.9,19H9.1L5,14.9V9.1L9.1,5h5.8L19,9.1V14.9z M14.83,7.76L12,10.59L9.17,7.76L7.76,9.17L10.59,12l-2.83,2.83l1.41,1.41L12,13.41l2.83,2.83l1.41-1.41L13.41,12l2.83-2.83 L14.83,7.76z" />
      </g>
    </>
  ),
  dnc: (
    <g>
      <path
        fill="inherit"
        d="M8.815 7.91667C8.85 8.43583 8.9375 8.94333 9.0775 9.4275L8.3775 10.1275C8.13833 9.4275 7.98667 8.68667 7.93417 7.91667H8.815ZM14.5667 14.9283C15.0625 15.0683 15.57 15.1558 16.0833 15.1908V16.06C15.3133 16.0075 14.5725 15.8558 13.8667 15.6225L14.5667 14.9283ZM9.375 6.75H7.33333C7.0125 6.75 6.75 7.0125 6.75 7.33333C6.75 12.8108 11.1892 17.25 16.6667 17.25C16.9875 17.25 17.25 16.9875 17.25 16.6667V14.6308C17.25 14.31 16.9875 14.0475 16.6667 14.0475C15.9433 14.0475 15.2375 13.9308 14.5842 13.715C14.5258 13.6917 14.4617 13.6858 14.4033 13.6858C14.2517 13.6858 14.1058 13.7442 13.9892 13.855L12.7058 15.1383C11.055 14.2925 9.70167 12.945 8.86167 11.2942L10.145 10.0108C10.3083 9.8475 10.355 9.62 10.2908 9.41583C10.075 8.7625 9.95833 8.0625 9.95833 7.33333C9.95833 7.0125 9.69583 6.75 9.375 6.75Z"
      />
      <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM4 12C4 7.58 7.58 4 12 4C13.85 4 15.55 4.63 16.9 5.69L5.69 16.9C4.63 15.55 4 13.85 4 12ZM12 20C10.15 20 8.45 19.37 7.1 18.31L18.31 7.1C19.37 8.45 20 10.15 20 12C20 16.42 16.42 20 12 20Z" />
    </g>
  ),
  csv: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.05882 23V1H14.6471V4.5C14.6471 4.77614 14.8841 5 15.1765 5H19.9412V23H4.05882ZM21 23.5C21 23.7761 20.763 24 20.4706 24H3.52941C3.23703 24 3 23.7761 3 23.5V0.5C3 0.223857 3.23703 0 3.52941 0H16.1443C16.2893 0 16.428 0.0561712 16.5279 0.155399L20.8542 4.45096C20.9478 4.54391 21 4.66728 21 4.79556V23.5Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.15789 9C1.51841 9 1 9.49746 1 10.1111V17.8889C1 18.5025 1.51841 19 2.15789 19H21.8421C22.4816 19 23 18.5025 23 17.8889V10.1111C23 9.49746 22.4816 9 21.8421 9H2.15789ZM8.55766 16.5508C8.96651 16.1992 9.19307 15.7174 9.23734 15.1055H8.06547C8.03943 15.4518 7.93656 15.7083 7.75688 15.875C7.57979 16.0391 7.31026 16.1211 6.94828 16.1211C6.54724 16.1211 6.25297 15.9792 6.06547 15.6953C5.88057 15.4115 5.78813 14.9622 5.78813 14.3477V13.918C5.79333 13.3294 5.89229 12.8958 6.085 12.6172C6.28031 12.3359 6.57328 12.1953 6.96391 12.1953C7.32328 12.1953 7.59021 12.2786 7.76469 12.4453C7.94177 12.6094 8.04464 12.875 8.07328 13.2422H9.24516C9.18266 12.6068 8.95089 12.1133 8.54984 11.7617C8.1488 11.4102 7.62016 11.2344 6.96391 11.2344C6.48995 11.2344 6.07328 11.3464 5.71391 11.5703C5.35714 11.7917 5.0824 12.1107 4.88969 12.5273C4.69698 12.944 4.60063 13.4258 4.60063 13.9727V14.3203C4.60063 15.1771 4.80896 15.8516 5.22563 16.3438C5.6449 16.8333 6.21911 17.0781 6.94828 17.0781C7.61495 17.0781 8.15141 16.9023 8.55766 16.5508ZM12.7617 15C12.918 15.1172 12.9961 15.2865 12.9961 15.5078C12.9961 15.7109 12.918 15.8698 12.7617 15.9844C12.6055 16.0964 12.388 16.1523 12.1094 16.1523C11.3594 16.1523 10.9844 15.8385 10.9844 15.2109H9.80859C9.80859 15.5781 9.90234 15.901 10.0898 16.1797C10.2799 16.4583 10.5547 16.6784 10.9141 16.8398C11.2734 16.9987 11.6719 17.0781 12.1094 17.0781C12.7396 17.0781 13.2409 16.9388 13.6133 16.6602C13.9857 16.3789 14.1719 15.9922 14.1719 15.5C14.1719 15.0573 14.0195 14.6875 13.7148 14.3906C13.4102 14.0938 12.9245 13.8451 12.2578 13.6445C11.8958 13.5352 11.6211 13.418 11.4336 13.293C11.2487 13.168 11.1562 13.013 11.1562 12.8281C11.1562 12.6302 11.2357 12.4714 11.3945 12.3516C11.5534 12.2292 11.776 12.168 12.0625 12.168C12.3594 12.168 12.5898 12.2409 12.7539 12.3867C12.918 12.5299 13 12.7318 13 12.9922H14.1719C14.1719 12.651 14.0833 12.3464 13.9062 12.0781C13.7318 11.8099 13.4857 11.6029 13.168 11.457C12.8503 11.3086 12.4883 11.2344 12.082 11.2344C11.6784 11.2344 11.3138 11.3021 10.9883 11.4375C10.6654 11.5729 10.4167 11.7617 10.2422 12.0039C10.0703 12.2435 9.98438 12.5169 9.98438 12.8242C9.98438 13.4154 10.3073 13.8854 10.9531 14.2344C11.1901 14.362 11.5117 14.4922 11.918 14.625C12.3242 14.7552 12.6055 14.8802 12.7617 15ZM18.3994 11.3125L17.1103 15.5898L15.8291 11.3125H14.5283L16.5009 17H17.7236L19.7041 11.3125H18.3994Z"
      />
    </g>
  ),
  doc: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.05882 23V1H14.6471V4.5C14.6471 4.77614 14.8841 5 15.1765 5H19.9412V23H4.05882ZM21 23.5C21 23.7761 20.763 24 20.4706 24H3.52941C3.23703 24 3 23.7761 3 23.5V0.5C3 0.223857 3.23703 0 3.52941 0H16.1443C16.2893 0 16.428 0.0561712 16.5279 0.155399L20.8542 4.45096C20.9478 4.54391 21 4.66728 21 4.79556V23.5Z"
      />
      <path d="M5.65922 16.0586V12.2617H6.23734C6.69828 12.2617 7.04854 12.4115 7.28813 12.7109C7.52771 13.0078 7.6475 13.4453 7.6475 14.0234V14.3242C7.64229 14.8815 7.51859 15.3099 7.27641 15.6094C7.03422 15.9089 6.68396 16.0586 6.22563 16.0586H5.65922Z" />
      <path d="M12.8945 12.668C13.1081 12.9779 13.2148 13.431 13.2148 14.0273V14.3047C13.2122 14.8958 13.1055 15.3464 12.8945 15.6562C12.6836 15.9635 12.3815 16.1172 11.9883 16.1172C11.5872 16.1172 11.2799 15.957 11.0664 15.6367C10.8529 15.3164 10.7461 14.8659 10.7461 14.2852V14.0078C10.7487 13.4167 10.8568 12.9688 11.0703 12.6641C11.2839 12.3568 11.5872 12.2031 11.9805 12.2031C12.3763 12.2031 12.681 12.3581 12.8945 12.668Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.15789 9C1.51841 9 1 9.49746 1 10.1111V17.8889C1 18.5025 1.51841 19 2.15789 19H21.8421C22.4816 19 23 18.5025 23 17.8889V10.1111C23 9.49746 22.4816 9 21.8421 9H2.15789ZM4.48734 11.3125V17H6.24906C6.74646 16.9974 7.19307 16.8828 7.58891 16.6562C7.98474 16.4297 8.29073 16.1107 8.50688 15.6992C8.72563 15.2878 8.835 14.8177 8.835 14.2891V14.0273C8.835 13.4987 8.72432 13.0273 8.50297 12.6133C8.28161 12.1966 7.97302 11.8763 7.57719 11.6523C7.18396 11.4258 6.73734 11.3125 6.23734 11.3125H4.48734ZM14.1055 15.7578C14.3034 15.3359 14.4023 14.8451 14.4023 14.2852V14.0312C14.4023 13.474 14.3008 12.9831 14.0977 12.5586C13.8971 12.1315 13.612 11.8047 13.2422 11.5781C12.875 11.349 12.4544 11.2344 11.9805 11.2344C11.5065 11.2344 11.0846 11.349 10.7148 11.5781C10.3477 11.8047 10.0625 12.1315 9.85938 12.5586C9.65885 12.9831 9.55859 13.4753 9.55859 14.0352V14.3164C9.5612 14.8633 9.66406 15.3477 9.86719 15.7695C10.0703 16.1888 10.3568 16.5117 10.7266 16.7383C11.0964 16.9648 11.5169 17.0781 11.9883 17.0781C12.4648 17.0781 12.8867 16.9635 13.2539 16.7344C13.6237 16.5052 13.9076 16.1797 14.1055 15.7578ZM19.0791 16.5508C19.4879 16.1992 19.7145 15.7174 19.7588 15.1055H18.5869C18.5608 15.4518 18.458 15.7083 18.2783 15.875C18.1012 16.0391 17.8317 16.1211 17.4697 16.1211C17.0686 16.1211 16.7744 15.9792 16.5869 15.6953C16.402 15.4115 16.3095 14.9622 16.3095 14.3477V13.918C16.3147 13.3294 16.4137 12.8958 16.6064 12.6172C16.8017 12.3359 17.0947 12.1953 17.4853 12.1953C17.8447 12.1953 18.1116 12.2786 18.2861 12.4453C18.4632 12.6094 18.566 12.875 18.5947 13.2422H19.7666C19.7041 12.6068 19.4723 12.1133 19.0713 11.7617C18.6702 11.4102 18.1416 11.2344 17.4853 11.2344C17.0114 11.2344 16.5947 11.3464 16.2353 11.5703C15.8785 11.7917 15.6038 12.1107 15.4111 12.5273C15.2184 12.944 15.122 13.4258 15.122 13.9727V14.3203C15.122 15.1771 15.3304 15.8516 15.747 16.3438C16.1663 16.8333 16.7405 17.0781 17.4697 17.0781C18.1364 17.0781 18.6728 16.9023 19.0791 16.5508Z"
      />
    </g>
  ),
  file: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.05882 23V1H14.6471V4.5C14.6471 4.77614 14.8841 5 15.1765 5H19.9412V23H4.05882ZM21 23.5C21 23.7761 20.763 24 20.4706 24H3.52941C3.23703 24 3 23.7761 3 23.5V0.5C3 0.223857 3.23703 0 3.52941 0H16.1443C16.2893 0 16.428 0.0561712 16.5279 0.155399L20.8542 4.45096C20.9478 4.54391 21 4.66728 21 4.79556V23.5Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.15789 9C1.51841 9 1 9.49746 1 10.1111V17.8889C1 18.5025 1.51841 19 2.15789 19H21.8421C22.4816 19 23 18.5025 23 17.8889V10.1111C23 9.49746 22.4816 9 21.8421 9H2.15789ZM5.34234 14.6758H7.59234V13.7305H5.34234V12.2617H7.87359V11.3125H4.17047V17H5.34234V14.6758ZM8.6675 17H9.83937V11.3125H8.6675V17ZM14.6294 16.0586H12.1411V11.3125H10.9692V17H14.6294V16.0586ZM16.517 14.5352H18.767V13.6172H16.517V12.2617H19.1498V11.3125H15.3452V17H19.1577V16.0586H16.517V14.5352Z"
      />
    </g>
  ),
  pdf: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.05882 23V1H14.6471V4.5C14.6471 4.77614 14.8841 5 15.1765 5H19.9412V23H4.05882ZM21 23.5C21 23.7761 20.763 24 20.4706 24H3.52941C3.23703 24 3 23.7761 3 23.5V0.5C3 0.223857 3.23703 0 3.52941 0H16.1443C16.2893 0 16.428 0.0561712 16.5279 0.155399L20.8542 4.45096C20.9478 4.54391 21 4.66728 21 4.79556V23.5Z"
      />
      <path d="M7.31156 14.0469H6.26469V12.2617H7.33891C7.62797 12.2669 7.85453 12.3555 8.01859 12.5273C8.18266 12.6992 8.26469 12.9245 8.26469 13.2031C8.26469 13.474 8.18266 13.6823 8.01859 13.8281C7.85714 13.974 7.62146 14.0469 7.31156 14.0469Z" />
      <path d="M11.4688 16.0586V12.2617H12.0469C12.5078 12.2617 12.8581 12.4115 13.0977 12.7109C13.3372 13.0078 13.457 13.4453 13.457 14.0234V14.3242C13.4518 14.8815 13.3281 15.3099 13.0859 15.6094C12.8438 15.9089 12.4935 16.0586 12.0352 16.0586H11.4688Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.15789 9C1.51841 9 1 9.49746 1 10.1111V17.8889C1 18.5025 1.51841 19 2.15789 19H21.8421C22.4816 19 23 18.5025 23 17.8889V10.1111C23 9.49746 22.4816 9 21.8421 9H2.15789ZM6.26469 17V14.9961H7.29203C7.96651 14.9961 8.49385 14.8359 8.87406 14.5156C9.25688 14.1927 9.44828 13.7526 9.44828 13.1953C9.44828 12.8281 9.36104 12.5013 9.18656 12.2148C9.01208 11.9258 8.76208 11.7031 8.43656 11.5469C8.11365 11.3906 7.73865 11.3125 7.31156 11.3125H5.09281V17H6.26469ZM10.2969 11.3125V17H12.0586C12.556 16.9974 13.0026 16.8828 13.3984 16.6562C13.7943 16.4297 14.1003 16.1107 14.3164 15.6992C14.5352 15.2878 14.6445 14.8177 14.6445 14.2891V14.0273C14.6445 13.4987 14.5339 13.0273 14.3125 12.6133C14.0911 12.1966 13.7826 11.8763 13.3867 11.6523C12.9935 11.4258 12.5469 11.3125 12.0469 11.3125H10.2969ZM16.7119 14.6758H18.9619V13.7305H16.7119V12.2617H19.2431V11.3125H15.54V17H16.7119V14.6758Z"
      />
    </g>
  ),
  users: (
    <g>
      <path d="M4 13C5.1 13 6 12.1 6 11C6 9.9 5.1 9 4 9C2.9 9 2 9.9 2 11C2 12.1 2.9 13 4 13ZM5.13 14.1C4.76 14.04 4.39 14 4 14C3.01 14 2.07 14.21 1.22 14.58C0.48 14.9 0 15.62 0 16.43V18H4.5V16.39C4.5 15.56 4.73 14.78 5.13 14.1ZM20 13C21.1 13 22 12.1 22 11C22 9.9 21.1 9 20 9C18.9 9 18 9.9 18 11C18 12.1 18.9 13 20 13ZM24 16.43C24 15.62 23.52 14.9 22.78 14.58C21.93 14.21 20.99 14 20 14C19.61 14 19.24 14.04 18.87 14.1C19.27 14.78 19.5 15.56 19.5 16.39V18H24V16.43ZM16.24 13.65C15.07 13.13 13.63 12.75 12 12.75C10.37 12.75 8.93 13.14 7.76 13.65C6.68 14.13 6 15.21 6 16.39V18H18V16.39C18 15.21 17.32 14.13 16.24 13.65ZM8.07 16C8.16 15.77 8.2 15.61 8.98 15.31C9.95 14.93 10.97 14.75 12 14.75C13.03 14.75 14.05 14.93 15.02 15.31C15.79 15.61 15.83 15.77 15.93 16H8.07ZM12 8C12.55 8 13 8.45 13 9C13 9.55 12.55 10 12 10C11.45 10 11 9.55 11 9C11 8.45 11.45 8 12 8ZM12 6C10.34 6 9 7.34 9 9C9 10.66 10.34 12 12 12C13.66 12 15 10.66 15 9C15 7.34 13.66 6 12 6Z" />
    </g>
  ),
  attachmentFlipped: (
    <svg
      viewBox="0 0 512.00 512.00"
      fill="#000000"
      transform="matrix(-1, 0, 0, 1, 0, 0)rotate(-45)"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0" />
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g id="SVGRepo_iconCarrier">
        {' '}
        <title>attach</title>{' '}
        <g id="Page-1" strokeWidth="0.00512" fill="none" fillRule="evenodd">
          {' '}
          <g
            id="add"
            fill="#000000"
            transform="translate(45.152000, 54.745600)"
          >
            {' '}
            <path
              d="M130.389333,396.672 C95.552,396.672 62.784,383.104 38.144,358.464 C-12.7146667,307.605333 -12.7146667,224.832 38.144,173.973333 L212.117333,-7.10542736e-15 L239.274667,27.1786667 L65.3013333,201.130667 C29.4186667,237.034667 29.4186667,295.424 65.3013333,331.306667 C82.688,348.693333 105.813333,358.272 130.389333,358.272 C154.965333,358.272 178.090667,348.693333 195.477333,331.306667 L367.594667,159.189333 C388.992,137.792 388.992,102.997333 367.594667,81.6 C346.858667,60.8426667 310.698667,60.9066667 290.005333,81.5786667 L121.450667,250.005333 C117.909333,253.546667 115.968,258.261333 115.968,263.274667 C115.968,268.288 117.909333,273.002667 121.472,276.544 C128.554667,283.690667 140.949333,283.648 148.032,276.544 L289.536,135.061333 L316.693333,162.24 L175.210667,303.722667 C152.874667,326.016 116.608,325.973333 94.3146667,303.722667 C72.0213333,281.429333 72.0213333,245.12 94.3146667,222.848 L262.869333,54.4426667 C280.448,36.8426667 303.893333,27.136 328.810667,27.136 C353.706667,27.136 377.130667,36.8213333 394.773333,54.4426667 C431.125333,90.816 431.125333,149.994667 394.773333,186.368 L222.634667,358.464 C197.994667,383.104 165.248,396.672 130.389333,396.672"
              id="attach"
            >
              {' '}
            </path>{' '}
          </g>{' '}
        </g>{' '}
      </g>
    </svg>
  ),
};

export default Icons;
